import Vue from "vue";
import Router from "vue-router";
import Home from "components/Home";
import Account from "components/user/Account";
import Login from "components/user/Login";
import ForgotPassword from "components/user/ForgotPassword";
import ChangePassword from "components/user/ChangePassword";
import Register from "components/user/Register";
import ConfirmPhone from "components/user/ConfirmPhone";
import ConfirmRules from "components/user/ConfirmRules";

import MapGenplan from "components/map/Genplan";
import PlotDetail from "components/map/PlotDetail";
import PaintAccessLine from "components/backoffice/map/PaintAccessLine";
import UseAccessLine from "components/backoffice/map/UseAccessLine";

import BackOffice from "components/backoffice/BackOffice";
import BackOfficeIndex from "components/backoffice/BackOfficeIndex";

import MapAdmin from "components/backoffice/map/MapAdmin";
import AddVillage from "components/backoffice/map/AddVillageCoord";
import PaintVillage from "components/backoffice/map/PaintVillageCoord";
import AddPlant from "components/backoffice/map/AddVillagePlant";
import AddCoords from "components/backoffice/map/AddCadastrCoord";
import MapCadastr from "components/backoffice/map/EditCadastr";

import OwnerAdmin from "components/backoffice/owner/OwnerAdmin";
import OwnersList from "components/backoffice/owner/OwnersList";
import MultiOwners from "components/backoffice/owner/MultiOwners";

import OrgAdmin from "components/backoffice/org/OrgAdmin";
import OrgAdd from "components/backoffice/org/OrgAdd";
import OrgList from "components/backoffice/org/OrgList";
import ServicesAdd from "components/backoffice/org/ServicesAdd";
import ServicesList from "components/backoffice/org/ServicesList";
import ContractTypeAdd from "components/backoffice/org/ContractTypeAdd";
import ContractTypeList from "components/backoffice/org/ContractTypeList";
import ContractTypeListRedaction from "components/backoffice/org/ContractTypeListRedaction";
import ContractTypeAddRedaction from "components/backoffice/org/ContractTypeAddRedaction";

import ParsecAccountsList from "components/backoffice/parsec/ParsecAccountsList";
import ParsecAccessLink from "components/backoffice/parsec/ParsecAccessLink";
import ParsecPasses from "components/backoffice/parsec/ParsecPasses";
import ParsecAdmin from "components/backoffice/parsec/ParsecAdmin";

import IntegrationsAdmin from "components/backoffice/integrations/IntegrationsAdmin";
import IntegrationAccountsList from "components/backoffice/integrations/IntegrationAccountsList";
import IntegrationTypesList from "components/backoffice/integrations/IntegrationTypesList";

import PaymentsList from "components/payments/PaymentsList";
import PaymentsAdmin from "components/payments/PaymentsAdmin";

import BypassAdmin from "components/backoffice/bypass/BypassAdmin";
import PassAdd from "components/backoffice/bypass/PassAdd";
import RfidAdd from "components/backoffice/bypass/RfidAdd";
import AutoPassAdd from "components/backoffice/bypass/AutoPassAdd";
import QRAdd from "components/backoffice/bypass/QRAdd";
import DoorControl from "components/backoffice/bypass/DoorControl";

import DocumentsMain from "components/backoffice/documents/DocumentsMain";
import Agreements from "components/backoffice/documents/Agreements";
import AccrualRules from "components/backoffice/documents/AccrualRules";
import Agreement from "components/backoffice/documents/get/Agreement";
import AgreementsAdd from "components/backoffice/documents/add/Agreement";
import Payment from "components/backoffice/documents/add/Payment";

import EditPlotsData from "components/backoffice/map/EditPlotsData";
import ListVilages from "components/lkuk/ListVilages";
import AdminLK from "components/lkAdmin/AdminLK";
import RegisterUK from "components/lkAdmin/RegisterUK";
import ListUserVillages from "components/lkAdmin/ListUserVillages";

import store from "../store";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/account",
      name: "Account",
      component: Account,
      meta: { authNeed: true }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { authNeed: false }
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: { authNeed: false }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: { authNeed: false }
    },
    {
      path: "/confirm-phone",
      name: "ConfirmPhone",
      component: ConfirmPhone,
      meta: { authNeed: false }
    },
    {
      path: "/confirm-rules",
      name: "ConfirmRules",
      component: ConfirmRules,
      meta: { authNeed: false }
    },
    {
      path: "/change-password",
      name: "ChangePassword",
      component: ChangePassword,
      meta: { authNeed: true }
    },
    {
      path: "/backoffice",
      component: BackOffice,
      meta: { authNeed: true },
      children: [
        {
          path: "org",
          component: OrgAdmin,
          meta: { ui: "pass" },
          children: [
            {
              path: "org-list",
              name: "OrgList",
              component: OrgList
            },
            {
              path: "org-add",
              name: "OrgAdd",
              component: OrgAdd
            },
            {
              path: "services-list",
              name: "ServicesList",
              component: ServicesList
            },
            {
              path: "services-add",
              name: "ServicesAdd",
              component: ServicesAdd
            },
            {
              path: "contract-type-add",
              name: "ContractTypeAdd",
              component: ContractTypeAdd
            },
            {
              path: "contract-type-list",
              name: "ContractTypeList",
              component: ContractTypeList
            },
            {
              path: "contract-type/:id",
              name: "ContractTypeListRedaction",
              component: ContractTypeListRedaction
            },
            {
              path: "contract-type/:id/add-redaction",
              name: "ContractTypeAddRedaction",
              component: ContractTypeAddRedaction
            },
            {
              path: "",
              redirect: "org-list"
            }
          ]
        },
        {
          path: "bypass",
          component: BypassAdmin,
          meta: { ui: "pass" },
          children: [
            {
              path: "passadd",
              name: "PassAdd",
              component: PassAdd
            },
            {
              path: "rfidadd",
              name: "RfidAdd",
              component: RfidAdd
            },
            {
              path: "autoadd",
              name: "AutoPassAdd",
              component: AutoPassAdd
            },
            {
              path: "qradd",
              name: "QRAdd",
              component: QRAdd
            },
            {
              path: "doorcontrol",
              name: "DoorControl",
              component: DoorControl
            },
            {
              path: "",
              redirect: "passadd"
            },
            {
              path: "paintaccessline",
              name: "PaintAccessLine",
              component: PaintAccessLine
            },
            {
              path: "useaccessline",
              name: "UseAccessLine",
              component: UseAccessLine
            }
          ]
        },
        {
          path: "documents",
          component: DocumentsMain,
          meta: { ui: "documents" },
          children: [
            {
              path: "agreements/:id",
              name: "Agreement",
              component: Agreement
            },
            {
              path: "agreements/:id/payment",
              name: "AgreementPayment",
              component: Payment
            },
            {
              path: "agreements",
              name: "Agreements",
              component: Agreements
            },
            {
              path: "agreement/add",
              name: "AgreementsAdd",
              component: AgreementsAdd
            },
            {
              path: "accrualrules",
              name: "AccrualRules",
              component: AccrualRules
            },
            {
              path: "",
              redirect: "agreements"
            }
          ]
        },
        {
          path: "owner",
          component: OwnerAdmin,
          meta: { ui: "owners" },
          children: [
            {
              path: "single",
              name: "Single",
              component: OwnersList
            },
            {
              path: "multi",
              name: "MultiOwners",
              component: MultiOwners
            },
            {
              path: "",
              redirect: "single"
            }
          ]
        },
        {
          path: "parsec",
          component: ParsecAdmin,
          meta: { ui: "parsec" },
          children: [
            {
              path: "account",
              name: "AccountParsec",
              component: ParsecAccountsList
            },
            {
              path: "link",
              name: "Link",
              component: ParsecAccessLink
            },
            {
              path: "passes",
              name: "Passes",
              component: ParsecPasses
            },
            {
              path: "",
              redirect: "account"
            }
          ]
        },
        {
          path: "integrations",
          component: IntegrationsAdmin,
          meta: { ui: "parsec" },
          children: [
            {
              path: "account",
              name: "AccountParsec",
              component: IntegrationAccountsList
            },
            {
              path: "types-for-kpp/:id",
              name: "TypeIntegration",
              component: IntegrationTypesList
            },
            {
              path: "",
              redirect: "account"
            }
          ]
        },
        {
          path: "",
          component: BackOfficeIndex
        }
      ]
    },
    {
      path: "/payments",
      component: PaymentsAdmin,
      meta: { ui: "payments" },
      children: [
        {
          path: "list",
          name: "List",
          component: PaymentsList
        },
        {
          path: "",
          redirect: "list"
        }
      ]
    },
    {
      path: "/lkuk",
      name: "LkUk",
      component: ListVilages,
      meta: { authNeed: true }
    },
    {
      path: "/admin",
      component: AdminLK,
      meta: {
        ui: "admin",
        authNeed: true,
        layout: "admin-layout"
      },
      children: [
        {
          path: "register-company",
          name: "RegisterUK",
          component: RegisterUK
        },
        {
          path: "users-villages",
          name: "ListUserVillages",
          component: ListUserVillages
        },
        {
          path: "map",
          component: MapAdmin,
          children: [
            {
              path: "addvillage",
              component: MapAdmin,
              children: [
                {
                  path: "1",
                  component: AddCoords
                },
                {
                  path: "2",
                  component: AddVillage
                },
                {
                  path: "2_2",
                  component: PaintVillage
                },
                {
                  path: "3",
                  component: AddPlant
                },
                {
                  path: "4",
                  component: EditPlotsData
                },
                {
                  path: "5",
                  component: MapCadastr
                },
                {
                  path: "",
                  redirect: "1"
                }
              ]
            },
            {
              path: "",
              redirect: "addvillage"
            }
          ]
        },
        {
          path: "",
          redirect: "register-company"
        }
      ]
    },
    {
      path: "/genplan/:id",
      name: "DetailPlot",
      component: PlotDetail,
      meta: { authNeed: true }
    },
    {
      path: "/genplan",
      name: "Genplan",
      component: MapGenplan,
      meta: { authNeed: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let authFail = false;
  to.matched.forEach(record => {
    if (record.meta.authNeed) {
      if (store.getters["auth/isAuthenticated"]) {
        next();
      } else {
        authFail = true;
        next("/login");
      }
    } else {
      next();
    }
  });

  if (!authFail) {
    to.matched.forEach(record => {
      if (record.meta.ui !== undefined) {
        if (store.getters["user/getProfileAccess"].includes(record.meta.ui)) {
          next();
        } else {
          next("/");
        }
      } else {
        next();
      }
    });
  }
});

export default router;
